/* eslint-disable react/no-multi-comp */
import React, { useEffect } from 'react';
import { Formik, useFormikContext } from 'formik';

import Searchbar from '@/components/commons/searchbar';
import SingleSelect from '@/components/forms/select/SingleSelect';

function MyNetworkSearchBar({
    setFilter, filter, setSearchTerm, searchTerm,
}) {
    function FormObserver() {
        const { values } = useFormikContext() as { values: { sort: string, filter: string } };

        useEffect(() => {
            if (filter !== values.filter) {
                setFilter(values.filter);
            }
        }, [values.filter]);
        return null;
    }

    const filterOptions = [
        {
            label: 'All contacts',
            value: 'all-contacts',
        },
        // {
        //     label: 'Sixty users only',
        //     value: 'sixty-users-only',
        // },
        {
            label: 'Only visible contacts',
            value: 'visible-only',
        },
        {
            label: 'Only non-visible contacts',
            value: 'invisible-only',
        },
        {
            label: 'Close',
            value: 'close',
        },
        {
            label: 'Medium',
            value: 'medium',
        },
        {
            label: 'Distant',
            value: 'distant',
        },
        // {
        //     label: 'New',
        //     value: 'new',
        // },
    ];

    const sortOptions = [
        {
            label: 'Alphabetical',
            value: 'alphabetical',
        },
        {
            label: 'Chronologically',
            value: 'chronologically',
        },
    ];

    return (
        <div className="flex flex-col md:flex-row items-center justify-start w-full">
            <div className="w-full mx-2 md:mx-0 md:mr-2 min-w-[220px]">
                <Searchbar placeholder="What are you looking for?" setSearchTerm={setSearchTerm} searchTerm={searchTerm} />
            </div>
            <Formik
                initialValues={{ filter: filterOptions[1].value, sort: sortOptions[0].value }}
                onSubmit={() => null}
            >
                <>
                    <div className="flex flex-col md:flex-row items-start md:items-center w-full">
                        <SingleSelect
                            options={filterOptions}
                            name="filter"
                            placeholder="Filter"
                            outerClassName="mx-0 md:mx-2 my-2 md:my-0 w-full md:w-auto"
                        />
                    </div>
                    <FormObserver />
                </>
            </Formik>
        </div>
    );
}

export default MyNetworkSearchBar;
